import { API_URL } from "../../constants/app";
import { headersJson, headersJsonToken } from "./requestHeaders";

export async function getUserDropDown(payload) {
    let res = await fetch(`${API_URL}/dropdown/user/list`, {
      method: "POST",
      headers: headersJsonToken(),
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        let modifiedData = [];
        data.body.data.forEach((val) => {
          modifiedData.push({
            value: val.id,
            label: val.fullName,
          });
        });
        return modifiedData;
      });
    return res;
}

export async function getIconDropDown(payload) {
  let res = await fetch(`${API_URL}/dropdown/icon/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: val.name,
          icon: val.icon
        });
      });
      return modifiedData;
    });
  return res;
}

export async function getRegionDropDown(payload) {
  let res = await fetch(`${API_URL}/dropdown/region/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: val.nameEn,
        });
      });
      return modifiedData;
    });
  return res;
}
export async function getNationalityDropDown(payload) {
  let res = await fetch(`${API_URL}/dropdown/nationality/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: val.name,
        });
      });
      return modifiedData;
    });
  return res;
}

export async function getTempleDropDown(payload) {
  let res = await fetch(`${API_URL}/dropdown/temple/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data?.body.data?.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: val.nameEn,
        });
      });
      return modifiedData;
    });
  return res;
}
export async function getTempleGroupDropDown(payload) {
  let res = await fetch(`${API_URL}/dropdown/temple-group/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: val.nameEn,
        });
      });
      return modifiedData;
    });
  return res;
}
export async function getZoneDropDown(payload) {
  let res = await fetch(`${API_URL}/dropdown/zone/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: val.name,
        });
      });
      return modifiedData;
    });
  return res;
}
export async function getProvinceDropDown(payload) {
  let res = await fetch(`${API_URL}/dropdown/province/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: val.nameEn,
        });
      });
      return modifiedData;
    });
  return res;
}
export async function getPurposeOfVisitDropDown(payload) {
  let res = await fetch(`${API_URL}/dropdown/purpose-of-visit/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: val.nameEn,
        });
      });
      return modifiedData;
    });
  return res;
}
export async function getTransportationDown(payload) {
  let res = await fetch(`${API_URL}/dropdown/transportation/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: val.nameEn,
        });
      });
      return modifiedData;
    });
  return res;
}
export async function getTypeOfFeedbackDown(payload) {
  let res = await fetch(`${API_URL}/dropdown/type-of-feedback/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: val.nameEn,
        });
      });
      return modifiedData;
    });
  return res;
}
export async function getUserDeleteReasonDropDown(payload) {
  let res = await fetch(`${API_URL}/dropdown/user-delete-reason/list`, {
    method: "POST",
    headers: headersJson(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: val.name,
        });
      });
      return modifiedData;
    });
  return res;
}
export async function editOrdering(payload) {
  let res = await fetch(`${API_URL}/dropdown/ordering/update`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
  return res;
}

export async function getTempleQrPanelTypeDropDown(payload) {
  let res = await fetch(`${API_URL}/dropdown/temple-qr-panel-type/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: val.name,
        });
      });
      return modifiedData;
    });
  return res;
}
